import type { ReactNode } from "react";

import { USStateChipItem } from "@similarweb/ui-components";

import { FilterChipVariant } from "../../types/commonEnums";
import FilterIconChip from "../FilterIconChip/FilterIconChip";

import { StyledCountryChip, StyledSimpleChip, StyledWebsiteChip } from "./styles";
import type { ChipComponentProps } from "./types";

export const renderChip = (variant: FilterChipVariant, props: ChipComponentProps): ReactNode => {
    // Callers always pass a zero-argument onCloseItem (see FiltersChip.tsx); CountryChipItem and
    // USStateChipItem declare a stricter () => void signature than IChipItemProps' (e: MouseEvent) => void.
    const onCloseItem = () => (props.onCloseItem as unknown as (() => void) | undefined)?.();

    switch (variant) {
        case FilterChipVariant.Country:
            return (
                <StyledCountryChip
                    {...props}
                    onCloseItem={onCloseItem}
                />
            );
        case FilterChipVariant.State:
            // code is guaranteed by callers for the State variant (FiltersChip's implicit contract)
            return (
                <USStateChipItem
                    {...props}
                    code={props.code!}
                    onCloseItem={onCloseItem}
                />
            );
        case FilterChipVariant.Icon:
            // iconName is guaranteed by callers for the Icon variant (FiltersChip's implicit contract)
            return (
                <FilterIconChip
                    {...props}
                    iconName={props.iconName!}
                />
            );
        case FilterChipVariant.Website:
            return <StyledWebsiteChip {...props} />;
        case FilterChipVariant.Default:
        default:
            return <StyledSimpleChip {...props} />;
    }
};
